<template>
  <div>
    <v-card>
      <manage-users-tabs current-tab="ManagePeerReviewers" />
      <v-toolbar flat color="white">
          <v-toolbar-title>Peer Reviewers</v-toolbar-title>
          <v-spacer />
          <search-filter v-model="keywordSearch" />
          <v-btn v-if="!readonly" color="secondary" dark @click="addDialog = true">
              Add
          </v-btn>
          <v-btn color="secondary" dark :loading="exporting" @click="exportUsers()">
              Export
          </v-btn>

      </v-toolbar>
      <v-data-table :headers="headers" :items="listData" :pagination.sync="pagination" :total-items="totalRecords" :loading="loading" :rows-per-page-items="rowsPerPageItems">
        <v-progress-linear slot="progress" color="secondary" indeterminate />
        <template slot="items" slot-scope="props">
          <td style="cursor:pointer" @click="props.expanded = !props.expanded">
            <i class="fas fa-chevron-right mr-4 expand-icon" :class="{rotate: props.expanded}" />
            {{ props.item.fullName }}
          </td>
          <td>{{ props.item.email }}</td>
          <td>
            <div v-if="props.item.institutionName">
              {{ props.item.institutionName }}
            </div>
            <div v-else>
              None
            </div>
          </td>
          <td>{{ props.item.registrationDate | formatDate }}</td>

          <td class="text-xs-right">
            <v-icon v-if="!readonly" class="mr-3" @click="popEditUserModal(props.item)">
              far fa-edit
            </v-icon>
            <v-icon v-if="!readonly" @click="deleteUser(props.item)">
              far fa-trash-alt
            </v-icon>
          </td>
        </template>

        <template v-slot:expand="props">
          <v-card flat class="py-3 px-3">
            <v-card-text>
              <p>
                <template v-if="props.item.phoneNumber ">
                  <b>Phone Number:</b> {{ props.item.phoneNumber }}<br>
                </template>
                <template v-if="props.item.institutionName ">
                    <b>Institution:</b> {{ props.item.institutionName }}<br>
                </template>
                <template v-if="props.item.referralType ">
                  <b>Referral Type:</b> {{ props.item.referralType }}<br>
                </template>
                <template v-if="props.item.positionType ">
                  <b>Position Type:</b> {{ props.item.positionType }}<br>
                </template>
                <template v-if="props.item.otherPositionTypeDetail ">
                  <b>Other Position Type:</b> {{ props.item.otherPositionTypeDetail }}<br>
                </template>
                <template v-if="props.item.programs.length ">
                  <b>Programs:</b> <span v-for="(role,index) in props.item.programs" :key="index">{{ role }}{{ props.item.programs.length -1 !== index ? ', ' : '' }}</span><br>
                </template>
                <b>Last Login Date:</b> {{ props.item.lastLoginDate | formatShortDate }}<br>
                <template v-if="props.item.bio ">
                  <b>Bio:</b> {{ props.item.bio }}
                </template>
              </p>
            </v-card-text>
          </v-card>
        </template>
      </v-data-table>
    </v-card>

    <add-user :dialog.sync="addDialog" :available-roles="availableRoles" @getUsers="getUsers" />
    <edit-user :dialog.sync="editDialog" :user="editingUser" :available-roles="availableRoles" @getUsers="getUsers" />
  </div>
</template>
<script>
  import _ from 'lodash';
  import localforage from 'localforage';
  import axios from 'axios';
  import ManageUsersTabs from './components/ManageUsersTabs.vue';
  import AddUser from './components/AddUser.vue';
  import EditUser from './components/EditUser.vue';

  export default {
    parent: true,

    components: {
      AddUser,
      ManageUsersTabs,
      EditUser,
    },

    props: {
      availableRoles: {
        type: Array,
        default: () => {},
        },
      readonly: {
          type: Boolean,
          default: false
            }
        },
    data: () => ({
      exporting: false,
      loading: true,
      listData: [],
      totalRecords: 0,
      rowsPerPageItems: [20, 50, 75, 100],
      pagination: {
        descending: false, page: 1, rowsPerPage: 20, sortBy: 'fullName', totalItems: 0,
      },
      keywordSearch: '',
      headers: [
        { text: 'Full Name', value: 'fullName', align: 'left' },
        {
          text: 'Email', value: 'email', align: 'left',
        },
        {
          text: 'Institution', value: 'institution', align: 'left',
        },
        {
          text: 'Register Date', value: 'registerDate', align: 'left',
        },
        {
          align: 'right', sortable: false,
        },
      ],
      addDialog: false,
      editDialog: false,
      editingUser: null,
    }),

    watch: {
      pagination: {
        handler(newval, oldval) {
          if (!_.isEqual(newval, oldval)) {
            this.getUsers();
          }
        },
        deep: true,
      },

      'pagination.rowsPerPage': function (val) {
        localforage.setItem('ManagePeerReviewers:RowsPerPage', val);
      },

      keywordSearch() {
        this.getUsers();
      },
    },

    mounted() {
      localforage.getItem('ManagePeerReviewers:RowsPerPage').then((value) => {
        this.pagination.rowsPerPage = value || 20;
        this.getUsers();
      });
    },

    methods: {
      async getUsers() {
        const {
          sortBy, descending, page, rowsPerPage,
        } = this.pagination;
        const sortDirection = descending ? `${sortBy} DESC` : `${sortBy} ASC`;
        this.loading = true;
        const { data } = await axios.get(`/api/users?role=peer-reviewer&currentPage=${page}&pageSize=${rowsPerPage}&sortDirection=${sortDirection}&filter=${this.keywordSearch}`);
        this.listData = data.resultItems;
        this.totalRecords = data.totalRecords;
        this.loading = false;
      },
      async exportUsers() {
        this.exporting = true;
        const { data } = await axios.get('/api/users/export?role=peer-reviewer', {
          responseType: 'blob',
        });
        const url = window.URL.createObjectURL(new Blob([data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', 'export.xlsx');
        document.body.appendChild(link);
        link.click();
        this.exporting = false;
      },
      async deleteUser(user) {
        const result = confirm('Are you sure you want to delete this user?'); // eslint-disable-line
        if (result) {
          await axios.delete(`/api/users/${user.id}`);
          await this.getUsers();
        }
      },

      popEditUserModal(user) {
        this.editingUser = user;
        this.editDialog = true;
      },

      processSearch: _.debounce(function () {
        this.getUsers();
      }, 600),
    },
  };
</script>